export default __webpack_public_path__ + "static/contact-6adef8e90b8910de86e6fc9c61edd9b1.png";